<script>
import { Component, Vue } from 'vue-property-decorator'
/* eslint-disable */
import Header from '@/components/common/Header'
import Login from '@/components/public/login'
/* eslint-disable */

@Component
export default class NotFound extends Vue {
  render() {
    return (
      <div>
        <Header class="header-black">
          <div class="header-nav header-nav-api">
            <router-link tag="div" to="/" class="by-newrank" />
            <Login />
          </div>
        </Header>
        <div class="error">
          <div class="error-img" />
          <p class="error-tip">
            发生错误，请点击<router-link to="/">返回首页</router-link>
          </p>
        </div>
      </div>
    )
  }
}
</script>

<style lang="postcss">
@import '../../assets/css/_pub.css';
.error {
  text-align: center;
  padding-top: 150px;
  &-img {
    @mixin size 292px, 189px;
    background: url(~@/assets/img/page_error.png) no-repeat;
    margin: auto;
  }
  &-tip {
    font-size: 18px;
    color: #606060;
    margin-top: 10px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/common/NotFound.vue